<template>
  <general-layout>
    <template #header>
      <east-operate>
        <template #left>
          <el-button
            size="mini"
            type="success"
            icon="el-icon-circle-plus-outline"
            @click="handleEdit()"
            >添加用户</el-button
          >
        </template>
        <template #right>
          <el-input
            placeholder="请输入姓名/账号"
            style="width:200px"
            size="mini"
            v-model.trim="inputKeyword"
            clearable
          >
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              title="搜索用户"
              @click="filterKeyword = inputKeyword"
              slot="append"
            >
            </el-button>
          </el-input>
        </template>
      </east-operate>
    </template>
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      v-loading="loading"
      border
    >
      <el-table-column prop="account" label="账号" width="140" />
      <el-table-column prop="name" label="姓名" width="160" />
      <el-table-column prop="phone" label="手机" width="130" />
      <el-table-column prop="email" label="邮箱" />
      <el-table-column label="状态" width="60" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.isEnable" class="text-success">启用</span>
          <span v-else class="text-danger">停用</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="90" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleEdit(scope.row)">
            编辑
          </el-button>
          <el-button type="text" size="mini" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加修改区 开始 -->
    <east-user
      :visible.sync="userShow"
      :userData="userData"
      @refresh="fetchData"
    >
    </east-user>
    <!-- 添加修改区 结束 -->
  </general-layout>
</template>
<script>
import EastUser from "./user";
import AUTH from "@/api/auth";
export default {
  data() {
    return {
      list: [],
      inputKeyword: "",
      filterKeyword: "",
      loading: true,
      userData: {},
      userShow: false
    };
  },
  components: {
    "east-user": EastUser
  },
  created() {
    this.fetchData();
  },
  computed: {
    tableData: vm =>
      vm.list.filter(
        u =>
          u.account.includes(vm.filterKeyword) ||
          u.name.includes(vm.filterKeyword)
      )
  },
  methods: {
    // 获取数据列表
    async fetchData() {
      let response = await AUTH.LIST();
      if (response.data.state) {
        this.list = response.data.users;
        this.loading = false;
      }
    },
    handleEdit(row) {
      this.userData = row;
      this.userShow = true;
    },
    async handleDelete(row) {
      try {
        await this.$confirm("删除不可恢复,确认?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        });
        let response = await AUTH.DELETE({ id: row.id });
        if (response.data.state) {
          // 刷新授权列表
          this.fetchData();
          this.$message.success("用户删除成功");
        } else {
          this.$message.error(response.data.message);
        }
        // eslint-disable-next-line no-empty
      } catch {}
    }
  }
};
</script>
<style lang="less" scoped>
.el-table__row {
  font-size: 13px;
}
.group-row td {
  font-weight: bold;
}
tr.row-hide {
  display: none;
}
.el-avatar {
  width: 22px;
  height: 22px;
  line-height: 22px;
  vertical-align: middle;
  color: #ffffff;
  font-size: 13px;
  margin-right: 4px;
}
</style>
